import React, { Component } from "react";
import "./style.css";
class TrinityResultExplain extends Component {
  render() {
    return (
      <div className="trinity_result_explain_box">
        <span style={{ color: "red" }}>*</span>{" "}
         依据26年三位一体报名条件符合的院校专业如下，其余见右上角说明。
      </div>
    );
  }
}

export default TrinityResultExplain;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityResult/components/TrinityResultExplain/index.js